import { Case } from '~/common/types/cases';

export const getCaseStatus = (caseItem: Case) => (caseItem.isClosed ? 'Closed' : 'Open');
